import { FullAudit, IsActiveFlag } from '@/types';

export interface CompanyModel extends IsActiveFlag, FullAudit {
    id: number;
    name: string;
    templateLogo: string | null;
    twoFactorAuthentication: string[];
    logoffByInactivity: number;
    passwordExpiration: number;
}
